<!-- Button -->
<button mat-icon-button [matMenuTriggerFor]="userActions">
    <span class="relative">
        <img class="w-7 h-7 rounded-full" *ngIf="showAvatar && user.avatar" [src]="user.avatar">
        <mat-icon *ngIf="!showAvatar || !user.avatar" [svgIcon]="'heroicons_outline:user-circle'" class="text-black"></mat-icon>
        <span class="absolute right-0 bottom-0 w-2 h-2 rounded-full" [ngClass]="{'mr-px mb-px': !showAvatar || !user.avatar,
                          'bg-green-500': user.status === 'online',
                          'bg-amber-500': user.status === 'away',
                          'bg-red-500': user.status === 'busy',
                          'bg-gray-400': user.status === 'not-visible'}"></span>
    </span>
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu">
    <div class="textCenter" style="padding:20px">
        <!-- <div>
            <span>Signed in as</span>
        </div> -->
        <div class="usrIcn"
            *ngIf="!attachments || (attachments && !attachments.length) || (attachments && attachments.length<1)">
            <mat-icon [svgIcon]="'heroicons_solid:user-circle'" class="text-black"></mat-icon>
        </div>
        <!-- <div class="usrIcn" > -->
        <!-- <mat-icon class="RmvBtn" svgIcon="mat_solid:close" (click)="removeImg(attachments[0])"></mat-icon> -->

        <!-- </div> -->
        <div *ngIf="attachments && attachments.length>0">
            <div class=" imgUploadDiv">
                <img [src]="attachments[0].base64" alt="Uploaded Image" />
            </div>
        </div>

        <div class="usrnm">
            <span class="lgnusrnme">{{user.fst_nm}}</span>
        </div>

        <div class="usrtmestmp">
            <span class="mt-1.5 "><span class="text-sm font-medium">Last login: </span><span
                    class="lgntme">{{user.lst_lgn_ts}}</span></span>
        </div>

    </div>
    <!-- </button> -->
    <mat-divider class="my-0"></mat-divider>
    <button mat-menu-item (click)="openProfile()" style="padding:20px">
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'" class="text-black"></mat-icon>
        <span>Profile</span>
    </button>
    <!-- <button mat-menu-item>
        <mat-icon [svgIcon]="'heroicons_outline:cog'"></mat-icon>
        <span>Settings</span>
    </button> -->
    <!-- <button
        mat-menu-item
        [matMenuTriggerFor]="userStatus">
        <mat-icon [svgIcon]="'heroicons_outline:dots-circle-horizontal'"></mat-icon>
        <span>Status</span>
    </button> -->
    <mat-divider class="my-0"></mat-divider>
    <button mat-menu-item (click)="signOut()" style="padding:20px">
        <mat-icon [svgIcon]="'heroicons_outline:logout'" class="text-black"></mat-icon>
        <span>Sign out</span>
    </button>
</mat-menu>

<!-- <mat-menu
    class="user-status-menu"
    #userStatus="matMenu">
    <button
        mat-menu-item
        (click)="updateUserStatus('online')">
        <span class="w-4 h-4 mr-3 rounded-full bg-green-500"></span>
        <span>Online</span>
    </button>
    <button
        mat-menu-item
        (click)="updateUserStatus('away')">
        <span class="w-4 h-4 mr-3 rounded-full bg-amber-500"></span>
        <span>Away</span>
    </button>
    <button
        mat-menu-item
        (click)="updateUserStatus('busy')">
        <span class="w-4 h-4 mr-3 rounded-full bg-red-500"></span>
        <span>Busy</span>
    </button>
    <button
        mat-menu-item
        (click)="updateUserStatus('not-visible')">
        <span class="w-4 h-4 mr-3 rounded-full bg-gray-400"></span>
        <span>Invisible</span>
    </button>
</mat-menu> -->